import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

const HeroSection = () => {
  const [conteudo, setConteudo] = useState<any>(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    carregarConteudo();
  }, []);

  const carregarConteudo = async () => {
    const { data } = await supabase
      .from('conteudo_inicio')
      .select('*')
      .eq('secao', 'hero')
      .maybeSingle();

    if (data) {
      setConteudo(data);
    }
  };

  const titulo = conteudo?.titulo || 'Transforme o seu futuro com a melhor qualidade digital';
  const subtitulo = conteudo?.subtitulo || 'Cursos e E-books Premium';
  const descricao = conteudo?.descricao || 'Aprenda com os melhores profissionais e desenvolva as competências que o mercado procura. Conteúdo exclusivo, prático e atualizado para impulsionar a sua carreira.';
  const botaoTexto = conteudo?.botao_texto || 'Explorar Cursos';
  const botaoLink = conteudo?.botao_link || '/produtos';
  const imagemUrl = conteudo?.imagem_url || 'https://public.readdy.ai/ai/img_res/df3d9580c849afb3e1e0c9bb97398a5b.jpg';

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #1a1200 0%, #0f0900 30%, #0A0A0A 60%, #120d00 100%)' }}
    >
      {/* Background Image - fades in when loaded */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={imagemUrl}
          alt="Hero Background"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          onLoad={() => setImageLoaded(true)}
          style={{
            opacity: imageLoaded ? 1 : 0,
            transition: 'opacity 0.6s ease-in-out',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 py-20">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-amber-500 bg-clip-text text-transparent drop-shadow-[0_0_30px_rgba(251,191,36,0.5)]">
                {titulo}
              </span>
            </h1>
            <p className="text-2xl md:text-3xl font-semibold mb-8">
              <span className="bg-gradient-to-r from-amber-300 via-yellow-300 to-amber-400 bg-clip-text text-transparent drop-shadow-[0_0_25px_rgba(252,211,77,0.6)] animate-pulse">
                {subtitulo}
              </span>
            </p>
            <p className="text-lg md:text-xl text-gray-100 mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)] font-medium">
              {descricao}
            </p>
            <Link
              to={botaoLink}
              className="inline-block px-10 py-5 bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-600 text-black font-bold text-lg rounded-lg hover:shadow-[0_0_30px_rgba(251,191,36,0.6)] transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-[0_0_20px_rgba(251,191,36,0.4)]"
            >
              {botaoTexto}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-yellow-400/70 rounded-full flex items-start justify-center p-2 shadow-[0_0_15px_rgba(251,191,36,0.4)]">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-yellow-400 rounded-full shadow-[0_0_10px_rgba(251,191,36,0.8)]"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;